import * as React from 'react';
import * as ValidateConstant from '../../wizard/constants/ValidateConstant';
import AssetsManager from '../utils/AssetsManager';
import {CheckboxProps} from '../types/components';

class Checkbox extends React.Component<CheckboxProps, {}> {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        customClass: '',
        listGroupClass: 'list-group-borderless'
    };

    onChange = (event, id, index) => {
        const checked = event.target.checked;
        const errorEmpty = this.validateEmpty(checked);
        const errorTerm = this.validateAccept(checked);
        this.props.onChange(checked, errorEmpty || errorTerm, index);
    }

    validateEmpty = value => this.props.required && !value ? ValidateConstant.ERROR_REQUIRED : null;

    validateAccept = value => !value ? ValidateConstant.ERROR_TERMS_MX_REQUIRED : null;

    renderLabel = (label, id) => {
        const {customClassLabel, superscriptLabel} = this.props;
        return (
            Array.isArray(label) ?
                (<label className="custom-control-label text-secondary-lighten-1"
                        htmlFor={id}>{label.map((item, index) => index === 0 ? item :
                    <span key={index} className="float-right">{item}</span>)}</label>)
                : (<label className={`custom-control-label ${customClassLabel}`} htmlFor={id}>
                    {label} <sup>{!!superscriptLabel && superscriptLabel}</sup>
                </label>)
        );
    }

    render() {
        const {
            id,
            name,
            label,
            options,
            customClass,
            listGroupClass,
            required,
            labelError,
            hasError,
            orientation,
            customClassWrapper
        } = this.props;
        const invalidClass = hasError && labelError && 'is-invalid';
        return (
            <div className={`form-group checkbox ${customClassWrapper ? customClassWrapper : ''}`}>
                {label ? <label>{label}{required && <span className="asterisk">*</span>}
                    {hasError && labelError && <img className="ic" alt=""
                                                    src={AssetsManager('/assets/images/common/warning-icon.svg')}/>}
                </label> : ''
                }
                <ul className={`list-group ${listGroupClass ? listGroupClass : ''} ${orientation ? orientation : ''}`}>
                    {options && options.map((item, index) => {
                        const inputId = `${id}-${index}`;
                        return (
                            <li key={index} className="list-group-item">
                                <div className={`${customClass} custom-control custom-checkbox`}>
                                    <input type="checkbox"
                                           className="custom-control-input"
                                           id={inputId}
                                           required={required}
                                           name={name}
                                           defaultChecked={item.defaultChecked}
                                           onChange={e => this.onChange(e, id, index)}
                                    />
                                    {this.renderLabel(item.label, inputId)}
                                </div>
                            </li>
                        );
                    })}
                </ul>
                {hasError && labelError &&
                <strong id={`${name}Help`}
                        className={`form-text ${invalidClass} text-left label-error`}>
                    {labelError}
                </strong>}
            </div>
        );
    }
}

export default Checkbox;
